import IonToolbar from '../../../../../components/Modal/ModalToolbar';
// import '@capacitor-community/http';
import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonModal, IonPage, IonTextarea, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, arrowForwardOutline, calendarOutline, copy, gridOutline, megaphoneOutline, sendOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { getDadosFinanceiros, pagamentoMensalidade, requestService } from '../../../../../Utils/Services';
import './MenuCampanhas.css';

type Props = {
    abrirMenu: boolean;
}

const MenuCampanhas: React.FC<Props> = (props: Props) => {

    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [showToast2, setShowToast2] = useState(false);
    const [showPerfil, setShowPerfil] = useState(false);
    const [perfil, setPerfil] = useState<any>("clientes");
    const {
        loja,
        setLoja,
        idPagamento,
        setIdPagamento,
        isPaymentCompleted,
        setIsPaymentCompleted
    } = useContext(MessageContext);

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    const [showLoading, setShowLoading] = useState(false);

    // Estados locais para pagamento (como no Inicio.tsx)
    const [showModalQrCode, setShowModalQrCode] = useState(false);
    const [qrCodeData, setQRCodeData] = useState<any>();
    const [qrCode, setQRCode] = useState<any>();
    const [valorPagamento, setValorPagamento] = useState<any>();
    const [timeLeft, setTimeLeft] = useState(6 * 60); // 10 minutos em segundos

    // const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
    const [dadosFinanceiros, setDadosFinanceiros] = useState<any>();
    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");
        carregarDadosFinanceiros();
    });

    // Função para carregar dados financeiros
    const carregarDadosFinanceiros = async () => {
        if (!loja) return;

        try {
            setShowLoading(true);
            const url = getDadosFinanceiros.url.replace("{id}", loja.replaceAll(/#/g, '%23'));

            await new Promise<void>((resolve, reject) => {
                requestService(
                    url,
                    {
                        method: 'GET',
                        timeout: 15000,
                    },
                    history,
                    (response) => {
                        if (response.Item) {
                            setDadosFinanceiros(response.Item);
                        } else {
                            setDadosFinanceiros(null);
                        }
                        resolve();
                    },
                    (error) => {
                        console.error("Erro ao carregar dados financeiros:", error);
                        setDadosFinanceiros(null);
                        resolve(); // Não falhar se não conseguir carregar
                    }
                );
            });
        } catch (error: any) {
            console.error("Erro ao carregar dados financeiros:", error);
            setDadosFinanceiros(null);
        } finally {
            setShowLoading(false);
        }
    };


    useEffect(() => {

        if (isPaymentCompleted && showModalQrCode) {
            carregarDadosFinanceiros();
            setShowModalQrCode(false);
            setIsPaymentCompleted(false);
        }

    }, [isPaymentCompleted]);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (showModalQrCode) {
            // Reseta o contador para 10 minutos sempre que o modal é aberto
            setTimeLeft(6 * 60); // 10 minutos em segundos (10 * 60)

            // Inicia o intervalo de 1 segundo para o countdown
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    if (prevTime > 0) {
                        return prevTime - 1;
                    } else {
                        clearInterval(timer); // Limpa o intervalo quando o tempo chega a 0
                        // Quando o tempo acaba, redireciona o usuário
                        handleQrCodeExpired();
                        return 0;
                    }
                });
            }, 1000);
        }

        // Limpa o timer quando o modal fecha ou o componente é desmontado
        return () => clearInterval(timer);

    }, [showModalQrCode]);

    // Função que será chamada quando o QR Code expira
    const handleQrCodeExpired = () => {
        setTextToast("Código expirado. Gere um novo para efetuar o pagamento.");
        setShowToast(true);

        setShowModalQrCode(false);
    };

    // Converte o tempo restante em minutos e segundos
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    return (
        <IonPage className="menu-layout-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="menu-layout-toolbar">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text=''></IonBackButton>
                    </IonButtons>
                    <IonTitle slot="start">Campanhas</IonTitle>
                </IonToolbar>


            </IonHeader>

            <IonContent className="menu-layout-content">
                <div className="menu-layout-container">
                    <div className="menu-layout-heading">
                        <h1>Campanhas</h1>
                        <p>Programe campanhas e acompanhe as mensagens enviadas aos seus clientes.</p>
                    </div>
                    {dadosFinanceiros && Object.keys(dadosFinanceiros).length > 0 && !showLoading && (
                        <button type="button" className="menu-campanhas-credit" onClick={async () => {
                            var token: string = "";
                            var tkn = localStorage.getItem("token");
                            if (typeof (tkn) === "string") { token = tkn; }

                            const objectRequest = {
                                compra: "1000mensagens"
                            }

                            let resp = await fetch(pagamentoMensalidade.url.replace("{id}", loja.replaceAll(/#/g, "%23")),
                                {
                                    method: pagamentoMensalidade.method,
                                    headers: [
                                        ["token", token]
                                    ],
                                    body: JSON.stringify(objectRequest),
                                    credentials: 'include'
                                });
                            let retorno = await resp.json();

                            if (resp.status === 400 || resp.status === 401) {
                                setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte.");
                                setShowToast(true);
                            }
                            else {
                                if (retorno.message) {
                                    setIdPagamento(retorno.message.id);
                                    setQRCode(retorno.message.point_of_interaction.transaction_data.qr_code);
                                    setQRCodeData(retorno.message.point_of_interaction.transaction_data.qr_code_base64);
                                    setValorPagamento(retorno.message.transaction_amount);
                                    setShowModalQrCode(true);
                                }
                                else {
                                    setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte.");
                                    setShowToast(true);
                                }
                            }
                        }}>
                            <span className="menu-campanhas-credit-icon"><IonIcon icon={megaphoneOutline} aria-hidden="true" /></span>
                            <span className="menu-campanhas-credit-text">
                                {(dadosFinanceiros.limiteMensagens && dadosFinanceiros.limiteMensagens > 0) ?
                                    (
                                        <>
                                            <strong>Você tem {dadosFinanceiros.limiteMensagens} mensagens disponíveis.</strong>
                                            <span>Continue enviando mensagens aos seus clientes!</span>
                                        </>
                                    )
                                    : (
                                        <>
                                            <strong>Suas mensagens acabaram.</strong>
                                            <span>Aproveite a promoção e adquira seu pacote de mensagens para vender mais!</span>
                                        </>
                                    )
                                }
                            </span>
                            <span className="menu-campanhas-buy">Comprar pacote<IonIcon icon={arrowForwardOutline} aria-hidden="true" /></span>

                        </button>
                    )}
                    <nav className="menu-layout-grid" aria-label="Campanhas">

                        <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>
                            Ações
                        </h2>


                        <div className="menu-campanhas-entry" hidden={acessos?.campanhas != 'leitura' && acessos?.campanhas != 'edicao'}>
                            <IonItem className="menu-layout-item" lines="none" button onClick={() => history.push("/empresa/programarmensagensclientes")} detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={calendarOutline} />
                                <IonLabel><h3>Programar</h3><p>Planeje o envio de mensagens aos clientes</p></IonLabel>
                            </IonItem>
                        </div>

                        <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>
                            Mensagens
                        </h2>

                        <div className="menu-campanhas-entry" hidden={acessos?.campanhas != 'leitura' && acessos?.campanhas != 'edicao'}>
                            <IonItem className="menu-layout-item" lines="none" button onClick={() => history.push("/empresa/painelmensagens")} detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={gridOutline} />
                                <IonLabel><h3>Painel de Mensagens</h3><p>Acompanhe os envios e seus resultados</p></IonLabel>
                            </IonItem>
                        </div>

                        <div className="menu-campanhas-entry" hidden={(acessos?.campanhas != 'leitura' && acessos?.campanhas != 'edicao') || loja !== 'empresa#3f6e3600833811f08a66f512c1f1fd2d'}>
                            <IonItem className="menu-layout-item" lines="none" button onClick={() => history.push("/empresa/enviarmensagensclientes")} detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={sendOutline} />
                                <IonLabel><h3>Enviar Agora</h3><p>Envie uma mensagem aos seus clientes</p></IonLabel>
                            </IonItem>
                        </div>

                    </nav>
                </div>

                <IonToast
                    isOpen={showToast}
                    position="middle" //top, bottom, middle
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />

                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    spinner="circles"
                />
                <IonModal className="fullscreen-modal" isOpen={showModalQrCode} onDidDismiss={() => {
                    setShowModalQrCode(false);
                }}>
                    <IonHeader className="ion-no-border">
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalQrCode(false)} />
                            </IonButtons>
                            <IonTitle>Detalhes do pagamento</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent>




                        <IonCard className="div-qrcode-pagamento">
                            <IonCardContent>

                                {/* Título Assinatura */}
                                <IonLabel className="qr-code-pagamento">
                                    <h2><b>Pacote de 1000 mensagens</b></h2>
                                </IonLabel>

                                {/* Valor do pagamento */}
                                <IonLabel>
                                    <p className="payment-title">Pague <b>R$ {valorPagamento?.toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}</b> via <b>Pix</b></p>
                                </IonLabel>

                                {/* Informações de vencimento */}
                                {/* <IonLabel>
                      <p className="payment-info">Vencimento: 30 minutos</p>
                    </IonLabel> */}

                                {/* Texto explicativo */}
                                <IonLabel className="qr-code-pagamento-margin">
                                    <h3>Para pagar, escolha uma destas opções:</h3>
                                </IonLabel>

                                {/* Código QR */}
                                <IonCardContent className="qr-code-pagamento">
                                    <IonLabel>
                                        <p>Código QR</p>
                                    </IonLabel>
                                    {qrCodeData && <img src={`data:image/png;base64,${qrCodeData}`} alt="QR Code" />}
                                </IonCardContent>

                                {/* Código de pagamento e botão de cópia */}
                                <IonCardContent className="qr-code-pagamento">
                                    <IonLabel>
                                        <p>Código de pagamento</p>
                                    </IonLabel>
                                    <div className="copy-code-container">
                                        {/* Substituído por IonTextarea */}
                                        <IonTextarea
                                            readonly={true}
                                            style={{ "--background": "#eeeeee" }}
                                            rows={2}
                                            value={qrCode}
                                        />
                                        <IonButton fill="clear" onClick={() => {
                                            navigator.clipboard.writeText(qrCode);
                                            setTextToast("Código copiado");
                                            setShowToast(true);
                                        }}>
                                            <IonIcon color="primary" icon={copy} />
                                        </IonButton>
                                    </div>

                                </IonCardContent>


                                <IonLabel className="qr-code-pagamento">
                                    Código válido por: <h1>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
                                </IonLabel>
                                {/* Instruções de como pagar */}
                                <IonCardContent>

                                    <IonLabel>
                                        <p><b>Como pagar?</b></p>
                                        <ol>
                                            <li>Entre no app ou site do seu banco e escolha a opção de pagamento via Pix.</li>
                                            <li>Escaneie o código QR ou copie e cole o código de pagamento.</li>
                                            <li>Pronto! Agora é só aguardar o pagamento ser processado.</li>
                                        </ol>
                                    </IonLabel>
                                </IonCardContent>


                            </IonCardContent>
                        </IonCard>








                    </IonContent>

                </IonModal>

            </IonContent>

        </IonPage>
    );
};

export default MenuCampanhas;
